import React from 'react';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import { Scope } from '@unform/core';
import Input from '~/components/Inputs/Input';
import InputMask from '~/components/Inputs/InputMask';
import InputCurrency from '~/components/Inputs/InputCurrency';

export default function PartnerFields({
  disabled = false,
  disabledFields = {},
}) {
  const isDisabled = fieldName =>
    Boolean(disabledFields?.[fieldName] ?? disabled);

  return (
    <>
      <Scope path="partner">
        <Row className="w-100 mx-0 font-size-20 font-weight-700 text-gray-700 my-4">
          Dados do Sócio Principal
        </Row>
        <Row className="w-100 mx-0">
          <Col lg={6} className="px-0 pr-lg-2">
            <FormGroup>
              <Label>Nome do Sócio</Label>
              <Input
                disabled={isDisabled('partner_name')}
                name="partner_name"
                placeholder="Nome do Sócio"
              />
            </FormGroup>
          </Col>
          <Col lg={6} className="px-0 pl-lg-2">
            <FormGroup>
              <Label>Email do Sócio</Label>
              <Input
                disabled={isDisabled('partner_email')}
                name="partner_email"
                placeholder="Email do Sócio"
                type="email"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="w-100 mx-0">
          <Col lg={6} className="px-0 pr-lg-2">
            <FormGroup>
              <Label>CPF do Sócio</Label>
              <InputMask
                disabled={isDisabled('partner_cpf')}
                name="partner_cpf"
                placeholder="CPF do Sócio"
                mask="999.999.999-99"
                maskChar={null}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col lg={6} className="px-0 pl-lg-2">
            <FormGroup>
              <Label>Data de Nascimento</Label>
              <InputMask
                disabled={isDisabled('partner_birth_date')}
                name="partner_birth_date"
                placeholder="Data de Nascimento (dd/mm/aaaa)"
                mask="99/99/9999"
                maskChar={null}
                type="text"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="w-100 mx-0">
          <Col lg={6} className="px-0 pr-lg-2">
            <FormGroup>
              <Label>Renda Mensal</Label>
              <InputCurrency
                disabled={isDisabled('partner_monthly_income')}
                name="partner_monthly_income"
                placeholder="Renda Mensal"
                type="text"
                currency
              />
            </FormGroup>
          </Col>
          <Col lg={6} className="px-0 pl-lg-2">
            <FormGroup>
              <Label>Ocupação Profissional</Label>
              <Input
                disabled={isDisabled('partner_professional_occupation')}
                name="partner_professional_occupation"
                placeholder="Ocupação Profissional"
              />
            </FormGroup>
          </Col>
        </Row>
      </Scope>
    </>
  );
}
